import { Image, Text } from "@sundae/ui-toolkit";
import cx from "classnames";
import Motion from "../Motion/Motion";
import { useI18N } from "@sundae/react-hooks";

const WelcomeDialog = () => {
  const { t } = useI18N("first-visits");

  return (
    <Motion className="grid place-items-center gap-4 text-center">
      <Image
        className={cx("pointer-events-none w-56")}
        height={400}
        src="/static/images/widgets/dex_swap_v1.png"
        width={400}
      />

      <Text tag="h2" size="2xl" weight="bold">
        {t("welcomeSlide.title")}
      </Text>
      <Text className="grid gap-4" tag="p">
        {t("welcomeSlide.intro")}:
        <Text className="grid gap-2" tag="ul">
          <Text tag="li">
            <Text tag="span" weight="bold">
              {t("welcomeSlide.features.feature1.title")}:
            </Text>{" "}
            {t("welcomeSlide.features.feature1.copy")}
          </Text>
          <Text tag="li">
            <Text tag="span" weight="bold">
              {t("welcomeSlide.features.feature2.title")}:
            </Text>{" "}
            {t("welcomeSlide.features.feature2.copy")}.
          </Text>
          <Text tag="li">
            <Text tag="span" weight="bold">
              {t("welcomeSlide.features.feature3.title")}:
            </Text>{" "}
            {t("welcomeSlide.features.feature3.copy")}
          </Text>
        </Text>
      </Text>
    </Motion>
  );
};

export default WelcomeDialog;
